var entities = require('html-entities');
var htmlEntities = new entities.AllHtmlEntities();

/**
 * Escape all entities (HTML + XML)
 * @param  {String} str
 * @return {String}
 */
function escape(str) {
    return htmlEntities.encode(str);
}

/**
 * Unescape all entities (HTML + XML)
 * @param  {String} str
 * @return {String}
 */
function unescape(str) {
    return htmlEntities.decode(str);
}

module.exports = {
    escape: escape,
    unescape: unescape
};



//////////////////
// WEBPACK FOOTER
// ../~/markup-it/syntaxes/html/utils.js
// module id = 331
// module chunks = 0